export default "__VITE_ASSET__7d260047__"